import { render, staticRenderFns } from "./Designer.vue?vue&type=template&id=1ea1734a&class=designer&"
import script from "./Designer.vue?vue&type=script&lang=ts&"
export * from "./Designer.vue?vue&type=script&lang=ts&"
import style0 from "./Designer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
